import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  inputContainer: {
    border: `1px solid ${colors.borderGray}`,
    borderRadius: 25,
    padding: '4px 5px 4px 8px',
    backgroundColor: '#FFF',
    '&:before': {
      color: colors.borderGray,
      verticalAlign: 'middle'
    }
  },
  searchBar: {
    height: '44px',
    width: '100%',
    borderRadius: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 20px',
    position: 'relative',
    background: 'white',
    border: '1px solid ' + colors.searchBorderGray
  },
  input: {
    width: 80,
    border: 'none',
    outline: 'none',
    marginLeft: 5,
    verticalAlign: 'middle',
    fontSize: 15,
    '&::placeholder': {
      color: colors.borderGray
    },
    '&:focus + .form-element-border': {
      visibility: 'visible',
      opacity: 1,
      transform: 'scale(1)',
      borderRadius: 25,
      left: 0
    }
  },
  inputAlt: {
    border: 'none',
    height: '25px',
    width: '95%',
    color: 'black',
    fontSize: '15px',
    outline: 'none',
    '&:focus ~ $labelLocal': {
      fontSize: '9px',
      top: '3px',
      color: 'black',
      transition: 'all 0.2s ease'
    },
    '&:focus ~ $highlight': {
      width: '90%',
      transition: 'all 0.3s ease'
    },
    '&:focus + .form-element-border': {
      visibility: 'visible',
      opacity: 1,
      transform: 'scale(1)',
      borderRadius: 25,
      left: 0
    },
    '&:not(:placeholder-shown) ~ $labelLocal': {
      fontSize: '9px',
      top: '3px'
    }
  },
  focused: {
    borderColor: 'transparent'
  },
  labelLocal: {
    color: colors.searchBorderGray,
    position: 'absolute',
    top: '10px',
    pointerEvents: 'none',
    transition: 'all 0.3s ease'
  },
  highlight: {
    width: '0px',
    height: '1px',
    background: 'black',
    position: 'absolute',
    bottom: '8px',
    transition: 'all 0.3s ease'
  }
}

export const useStyles = createUseStyles(style)
